import { Dispatch, SetStateAction } from 'react';

import { FULL_PERCENT, PROGRESS_INTERVAL } from '@hooks/constants';
import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckAwtgRanProgress } from '@api/hitoryCheck';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { TAwtgRanProgressResponse } from '@interfaces/cmModule/dto/historyCheckDTO';
import { IResponseError } from '@interfaces/errors/apiErrors';

import { EVendorsValues } from '@enums/common';

import { HISTORY_CHECK_AWTG_RAN_GET_PROGRESS } from '@constants/queryKeys';

interface IUseQueryHistoryCheckAwtgRanProgressParams {
	vendor?: string;
	progressId?: string;
	isProgressRun: boolean;
	setIsProgressRun: Dispatch<SetStateAction<boolean>>;
}

interface IUseQueryHistoryCheckAwtgRanProgressReturnValue {
	progressData?: TAwtgRanProgressResponse;
}

export const useQueryHistoryCheckAwtgRanProgress = (
	params: IUseQueryHistoryCheckAwtgRanProgressParams,
): IUseQueryHistoryCheckAwtgRanProgressReturnValue => {
	const {
		vendor,
		progressId,
		setIsProgressRun,
		isProgressRun,
	} = params;

	const isAwtgRanVendor = vendor === EVendorsValues.oran;

	const {
		data: progressData,
	} = useQuery<TAwtgRanProgressResponse | undefined>({
		queryKey: [
			HISTORY_CHECK_AWTG_RAN_GET_PROGRESS,
			progressId,
		],
		queryFn: () => {
			if (progressId) return getHistoryCheckAwtgRanProgress(progressId);

			setIsProgressRun(false);
		},
		onSuccess: (data) => {
			if (data?.percentsProgress == FULL_PERCENT && progressId) {
				setIsProgressRun(false);
			}
		},
		onError: (err: IResponseError) => {
			setIsProgressRun(false);
			handleErrorFromMessage(err);
		},
		enabled: [!!progressId, isProgressRun, isAwtgRanVendor],
		refetchInterval: isProgressRun ? PROGRESS_INTERVAL : false,
	});

	return { progressData };
};
